import React from "react";
import ftmlogo from "../assets/images/fresh-thyme-market-logo.png";

export default function EmployeeStatusPage({data}) {
    const getStatusClass = (status) => {
        if (!status) return "status-circle gray";
        return status.toLowerCase() === "active"
            ? "status-circle green"
            : "status-circle orange";
    };

    const warnings = [];
    if (data?.loyaltyIdVerification === false)
        warnings.push("LoyaltyId does not match.");
    if (data?.emailVerification === false)
        warnings.push("Email not matched, Please verify in workday.");
    if (data?.phoneVerification === false)
        warnings.push("Phone not matched, Please verify in workday.");

    return (
        <div className="employee-container">
            <div className="card">
                <img src={ftmlogo} alt="Fresh Thyme Market logo" width="auto"
                     height="auto"/>
                <h2 className="card-title">Employee Status</h2>
                <div className="legend">
                    <div className="legend-item">
                        <div className="status-circle green"></div>
                        <span>Active</span>
                    </div>
                    <div className="legend-item">
                        <div className="status-circle orange"></div>
                        <span>Inactive</span>
                    </div>
                    <div className="legend-item">
                        <div className="status-circle gray"></div>
                        <span>N/A</span>
                    </div>
                </div>
                <div className="email-cell">Email: {data?.email}</div>
                <div className="email-cell">Phone: {data?.phone}</div>

                <div className="status-row">
                    <span>Employee Status</span>
                    <div className={getStatusClass(data?.employeeLinkedStatus)}></div>
                </div>
                <div className="status-row">
                    <span>Discount Status</span>
                    <div className={getStatusClass(data?.discountStatus)}></div>
                </div>

                {warnings.length > 0 && (
                    <div className="warning-box">
                        {warnings.map((msg, i) => (
                            <div key={i} className="warning-text">
                                {msg}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
